import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var PaperplaneSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M20.59 2.126L2.488 12.57a.938.938 0 00.086 1.688l4.151 1.741 11.22-9.888c.215-.192.52.101.337.324L8.873 17.896v3.144c0 .922 1.113 1.285 1.66.617l2.48-3.018 4.866 2.038a.94.94 0 001.289-.71L21.98 3.094c.133-.79-.715-1.36-1.39-.969z", fill: "currentColor" })] })));
};

export { PaperplaneSolidIcon };
//# sourceMappingURL=PaperplaneSolidIcon.js.map
